import SkipNextIcon from "@mui/icons-material/SkipNextRounded";
import SkipPreviousIcon from "@mui/icons-material/SkipPreviousRounded";
import { Pagination, PaginationItem } from "@mui/material";

interface Props {
  totalPages: number | undefined;
  pageIndex: number;
  onPageIndexChange: (value: number) => void;
}

const PaginationControl = ({ totalPages, pageIndex, onPageIndexChange }: Props) => (
  <Pagination
    color="primary"
    showFirstButton
    showLastButton
    page={pageIndex + 1}
    count={totalPages}
    onChange={(_, pageNum) => onPageIndexChange(pageNum - 1)}
    renderItem={(item) => <PaginationItem slots={{ first: SkipPreviousIcon, last: SkipNextIcon }} {...item} />}
  />
);

export default PaginationControl;
